import * as React from 'react';
import { Button, ITagOption, Tags } from '@cian/ui-kit';
import { useDispatch, useSelector } from 'react-redux';

import { definitions } from '../../actions/filterTags/definitions';
import { IStateTag, updateTags } from '../../actions/filterTags';
import { getOffersData } from '../../actions/offersData';
import { TagLayout } from '../../components/TagLayout';
import { getTags } from '../../selectors/filters';
import { TTypedThunkDispatch } from '../../types/thunk';
import { getTagIcon } from './getTagIcon';
import { IconActionMore16 } from '@cian/ui-kit-design-tokens/icons';

const displayModeOptions = {
  hideText: undefined,
  isFoldable: true,
  isFolded: true,
  maxLines: 1,
  showMoreText: undefined,
  expandCollapseAdornment: (isExpanded: boolean) => (
    <Button
      theme="fill_white_primary"
      size="XS"
      beforeIcon={isExpanded ? undefined : <IconActionMore16 color="current_color" />}
    >
      {isExpanded ? 'Свернуть' : ''}
    </Button>
  ),
};

export const FilterTags = () => {
  const dispatch = useDispatch<TTypedThunkDispatch>();
  const tags = useSelector(getTags);

  const clearAllTags = React.useCallback(() => {
    tags.forEach(tag => {
      const definition = definitions.get(tag.keyName);
      if (definition) {
        const onDeleteAction = definition.onDeleteAction(tag.value, { skipUpdateOffersCount: true });
        if (onDeleteAction) {
          dispatch(onDeleteAction);
        }
      }
    });
    dispatch(getOffersData());
    dispatch(updateTags());
  }, [dispatch, tags]);

  const options = React.useMemo<ITagOption[]>(
    () =>
      tags.map(tag => {
        const mappedTag = {
          label: tag.label,
          value: JSON.stringify(tag.value) + '/' + tag.label, // Китовые теги требует уникальное значение в value.
          icon: getTagIcon(tag),
        };

        return mappedTag;
      }),
    [tags],
  );

  const deleteTag = React.useCallback(
    (option: ITagOption) => {
      const tag = tags.find(tag => JSON.stringify(tag.value) + '/' + tag.label === option.value) as IStateTag;
      const definition = definitions.get(tag.keyName);

      if (definition) {
        dispatch(definition.onDeleteAction(tag.value));
      }
    },
    [dispatch, tags],
  );

  if (!tags.length) {
    return null;
  }

  return (
    <TagLayout>
      <Tags
        options={options}
        onClose={deleteTag}
        displayModeOptions={displayModeOptions}
        rightAdornment={
          <Button size="XS" theme="fill_white_primary" type="button" onClick={clearAllTags}>
            Очистить
          </Button>
        }
      />
    </TagLayout>
  );
};
